import Carousel from "@components/Carousel/Carousel";
import ProductCard from "@components/Product/ProductCard/ProductCard";
import PageSection, {PageSectionProps} from "@components/Page/PageSection";
import React from "react";
import {CmsSection} from "@lib/Cms/CmsModels";
import {useCatalog} from "@lib/Catalog/CatalogHooks";

interface CatalogPreviewProps {
    cms: CmsSection;
}

const CatalogPreview = ({cms}: CatalogPreviewProps) => {

    const pageSectionProps: PageSectionProps = {
        title: cms.title,
        description: cms.text,
        link: cms.cta?.[0] ? {
            label: cms.cta[0].title,
            href: cms.cta[0].scope
        } : null
    }

    const {data: products = [], isLoading, isError} = useCatalog(8);

    if ( isLoading || isError || products.length === 0 ) {
        return null;
    }

    return (
        <PageSection {...pageSectionProps} bg={cms.options?.bg}>
            <Carousel settings={{
                breakpoints: {
                    425: {slidesPerView: 1.2},
                    768: {slidesPerView: 2.2},
                    1024: {slidesPerView: 4}
                }
            }} withArrows withNav>

                {products.map((p) => (
                    <ProductCard
                        key={`${p.categoryName}-${p.title}-${p.points}`}
                        image={p.image}
                        categoryName={p.categoryName}
                        title={p.title}
                        points={p.points}
                        linkProps={p.linkProps}
                    />
                ))}

            </Carousel>
        </PageSection>
    );

}

export default CatalogPreview;